(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-interface-upgrades"] && !Shopify.designMode) return;
  try {
    (function () {
  var badgeSelector = '.jdgm-preview-badge--with-link';
  function reviewPanel() {
    return document.getElementById('ptabReview');
  }
  function syncAccordion(root) {
    root.querySelectorAll('.acor-ttl .tablink').forEach(function (link) {
      link.setAttribute('aria-controls', link.getAttribute('href').slice(1));
      link.setAttribute('aria-expanded', String(link.parentElement.classList.contains('active')));
    });
  }
  function showReviews(event) {
    var target = event.target instanceof Element ? event.target : null;
    var badge = target && target.closest(badgeSelector);
    var panel = reviewPanel();
    var root = panel && panel.closest('#productTabs');
    if (!badge || !panel || !root) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    var widget = panel.querySelector('.jdgm-review-widget');
    if (widget && badge.dataset.id && widget.dataset.id && badge.dataset.id !== widget.dataset.id) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    root.querySelectorAll('.tab-content').forEach(function (content) {
      if (typeof window.jQuery === 'function') window.jQuery(content).stop(true, true);
      content.style.display = content === panel ? 'block' : 'none';
    });
    root.querySelectorAll('.product-tabs li,.acor-ttl').forEach(function (heading) {
      var link = heading.querySelector('.tablink');
      heading.classList.toggle('active', Boolean(link && link.getAttribute('href') === '#ptabReview'));
    });
    syncAccordion(root);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var header = document.getElementById('header');
        var clearance = Math.max(header ? header.getBoundingClientRect().height + 24 : 0, window.innerWidth < 767 ? 100 : 150);
        var mobileHeading = panel.previousElementSibling;
        var anchor = mobileHeading && mobileHeading.matches('.acor-ttl') && mobileHeading.getBoundingClientRect().height > 0 ? mobileHeading : panel;
        var top = Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - clearance);
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var link = target && target.closest('#productTabs .tablink');
    if (link) {
      window.requestAnimationFrame(function () {
        var panel = reviewPanel();
        var root = panel && panel.closest('#productTabs');
        if (root) syncAccordion(root);
      });
    }
    showReviews(event);
  }, true);
  document.addEventListener('keydown', showReviews, true);
})();
  } catch(e) { console.error(e); }
})();

})();
